import React from 'react';


const LogoRexImage = '/assets/images/LogoRexAsistencia.png';


interface LogoRexProps {
  className?: string;
  alt?: string;
}

export const LogoRex: React.FC<LogoRexProps> = ({
  className = 'h-8 mx-auto mb-4',
  alt = 'Rex Asistencia',
}) => (
  <img
    src={LogoRexImage}
    alt={alt}
    className={className}
  />
);
